import { render, staticRenderFns } from "./carts.vue?vue&type=template&id=272c2444"
import script from "./carts.vue?vue&type=script&lang=js"
export * from "./carts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports